import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import pickBy from 'lodash/pickBy';

import {revertLocationParamsConvertion} from 'app/store/sweet-api/utils';

import type {
  DocumentFetchParamsType,
  DocumentLocationParamsType,
} from './types';
import type {DefaultRootState} from 'react-redux';
import type {ContentType} from 'sweet-types';

interface ToggleDashboard {
  contentType: ContentType;
  isOpen: boolean;
}

interface DashboardState {
  filters: DocumentLocationParamsType;
  relations: Record<ContentType, boolean> | Record<string, never>;
}

const initialState: DashboardState = {
  filters: {} as DocumentLocationParamsType,
  relations: {},
};

const documentsSlice = createSlice({
  name: 'documents',
  initialState,
  reducers: {
    toggleDashboardRelation(state, action: PayloadAction<ToggleDashboard>) {
      state.relations[action.payload.contentType] = action.payload.isOpen;
    },
    setDocumentFilters(state, action: PayloadAction<DocumentFetchParamsType>) {
      state.filters = revertLocationParamsConvertion({
        ...action.payload,
        folder: undefined,
      });
    },
  },
});

export const {toggleDashboardRelation, setDocumentFilters} =
  documentsSlice.actions;

export const selectDocumentFilters = (
  state: DefaultRootState
): DocumentLocationParamsType => pickBy(state.documents.filters);

export const documentsReducer = documentsSlice.reducer;
